export const removeAllFromLocalStorage = (...ignoredKeys: string[]) => {
  if (!ignoredKeys?.length) return localStorage.clear()

  Object.keys(localStorage)
    .filter((key) => !ignoredKeys.includes(key))
    .forEach((key) => {
      localStorage.removeItem(key)
    })
}
